const challenges = [
  "A process that depends on manual work",
  "Knowledge trapped across people and documents",
  "Customer friction that keeps repeating",
  "Data that does not support decisions",
  "An AI product opportunity to test",
];

const products = [
  "AI assistants and knowledge copilots",
  "Workflow automations",
  "Internal business tools",
  "Data and intelligence products",
  "Working AI product prototypes",
];

const BuildSystemSection = () => {
  return (
    <section className="apl-section apl-section-soft">
      <div className="apl-shell">
        <div className="apl-section-head apl-reveal">
          <div>
            <div className="apl-eyebrow">What enters. What leaves.</div>
            <h2>The challenge shapes the product.</h2>
          </div>
          <p>
            The Lab is a bridge between the problem you understand and the
            product your organisation needs to test.
          </p>
        </div>

        <div
          className="apl-lab-system apl-reveal"
          aria-label="How business challenges become AI products"
        >
          <div className="apl-system-column">
            <div className="apl-system-label">Challenges entering the Lab</div>
            {challenges.map((challenge) => (
              <div className="apl-system-card" key={challenge}>
                {challenge}
              </div>
            ))}
          </div>

          <div className="apl-lab-core">
            <div>
              <small>Utiva AI Product Lab</small>
              <strong>
                Diagnose.
                <br />
                Build.
                <br />
                Prove.
              </strong>
              <p>
                A multidisciplinary team shaped around one business challenge.
              </p>
            </div>
          </div>

          <div className="apl-system-column">
            <div className="apl-system-label">Products leaving the Lab</div>
            {products.map((product) => (
              <div className="apl-system-card apl-output" key={product}>
                {product}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuildSystemSection;
